import {h, Fragment} from "preact"
import { useActions, useAppState } from '@nosto/preact'
import { defaultConfig, sizes } from '../config'
import Pagination from './Pagination'

const parseInteger = (value) => (value && !Number.isNaN(value) ? Number.parseInt(`${value}`) : 0)

export default () => {
    const { query, response } = useAppState()
    const { updateSearch } = useActions()

    const from = parseInteger(query.products?.from)
    const size = parseInteger(response.products.size)
    const total = parseInteger(response.products.total)

    const sizeOptions = [...sizes].reverse().filter((value) => value + defaultConfig.serpSize < total)

    return (
        <div class="ns-my-4 ns-mx-0">
            <Pagination />
        </div>
    )
}
